/**
 * The ViewRenderState enum represents the render state of a particular view.
 * It applies to components that explicitly fetch data.
 */ export var ViewRenderState = /*#__PURE__*/ function(ViewRenderState) {
    // All data is rendered within the component
    ViewRenderState[ViewRenderState["All"] = 2] = "All";
    // Visually critical data sufficient to make the component feel loaded is rendered
    ViewRenderState[ViewRenderState["Critical"] = 1] = "Critical";
    // No data is yet rendered and the view is empty
    ViewRenderState[ViewRenderState["None"] = 0] = "None";
    return ViewRenderState;
}({});
/**
 * The ViewDataFetchState enum represents the state of the view data fetch.
 * TODO: Move this to a number based enum so that it has a semantic order
 */ export var ViewDataFetchState = /*#__PURE__*/ function(ViewDataFetchState) {
    // The data fetch is started
    ViewDataFetchState[ViewDataFetchState["Started"] = 0] = "Started";
    // The data fetch is completed
    ViewDataFetchState[ViewDataFetchState["Completed"] = 1] = "Completed";
    return ViewDataFetchState;
}({});
/**
 * The ViewName enum represents the different view names to be used in the performance markers.
 */ export var ViewName = /*#__PURE__*/ function(ViewName) {
    ViewName["PlanPage"] = "PlanPage";
    ViewName["PlanBoard"] = "PlanBoard";
    ViewName["PlanCalendar"] = "PlanCalendar";
    ViewName["PlanTeamView"] = "PlanTeamView";
    ViewName["LeftNavContainer"] = "LeftNavContainer";
    ViewName["UnoLeftNavContainer"] = "UnoLeftNavContainer";
    ViewName["MyDayPage"] = "MyDayPage";
    ViewName["MyTasksPage"] = "MyTasksPage";
    ViewName["MyTasksListPage"] = "MyTasksListPage";
    ViewName["MyPlansPage"] = "MyPlansPage";
    ViewName["MyPlansList"] = "MyPlansList";
    ViewName["MyPortfoliosPage"] = "MyPortfoliosPage";
    ViewName["PortfolioPage"] = "PortfolioPage";
    ViewName["BasicPlanPage"] = "BasicPlanPage";
    ViewName["TaskEditorContainer"] = "TaskEditorContainer";
    ViewName["ChatThreadContainer"] = "ChatThreadContainer";
    ViewName["TaskLinkToast"] = "TaskLinkToast";
    ViewName["TaskMoveToast"] = "TaskMoveToast";
    ViewName["TaskCopyToast"] = "TaskCopyToast";
    ViewName["CreateTeamsTabPage"] = "CreateTeamsTabPage";
    ViewName["CreateTaskPage"] = "CreateTaskPage";
    ViewName["RemoveTeamsTabPage"] = "RemoveTeamsTabPage";
    ViewName["TeamsTabLandingExperienceContainer"] = "TeamsTabLandingExperienceContainer";
    ViewName["PremiumPlanPage"] = "PremiumPlanPage";
    ViewName["ConfigTeamsTabPage"] = "ConfigTeamsTabPage";
    ViewName["NewTabPage"] = "NewTabPage";
    ViewName["PublishingPage"] = "PublishingPage";
    ViewName["UnifiedPlanPage"] = "UnifiedPlanPage";
    ViewName["CreatePlanModal"] = "CreatePlanModal";
    ViewName["CreatePortfolioModal"] = "CreatePortfolioModal";
    ViewName["SharePlanDialog"] = "SharePlanDialog";
    ViewName["CopyPlanModal"] = "CopyPlanModal";
    ViewName["SuiteNavContainer"] = "SuiteNavContainer";
    ViewName["PlannerShell"] = "PlannerShell";
    ViewName["GridPage"] = "GridPage";
    ViewName["PlannerCopilotPane"] = "PlannerCopilotPane";
    return ViewName;
}({});
/**
 * Empty state view type
 */ export var EmptyStateViewType = /*#__PURE__*/ function(EmptyStateViewType) {
    /** Empty state view for no plans */ EmptyStateViewType["NoPlansAvailable"] = "noPlansAvailable";
    /** Empty state view for no plans found */ EmptyStateViewType["NoPlansFound"] = "noPlansFound";
    /** Service error empty state view */ EmptyStateViewType["ServiceError"] = "serviceError";
    /** Empty state view for no portfolios available */ EmptyStateViewType["NoPortfoliosAvailable"] = "noPortfoliosAvailable";
    /** Empty state view for no tasks found for applied filters */ EmptyStateViewType["NoTasksFoundForAppliedFilters"] = "noTasksFoundForAppliedFilters";
    return EmptyStateViewType;
}({});
/**
 * View display state enum used to determine which view to render:
 * actual data view, empty state view, or loading view.
 */ export var ViewDisplayState = /*#__PURE__*/ function(ViewDisplayState) {
    /** Data is available regardless of filters */ ViewDisplayState["DataAvailable"] = "DA";
    /** Data is available but filtered out completely */ ViewDisplayState["DataAvailableButFiltered"] = "DAF";
    /** Data is not available after fetching */ ViewDisplayState["DataNotAvailable"] = "DNA";
    /** Data is not fetched (being fetched) */ ViewDisplayState["DataNotFetched"] = "DNF";
    return ViewDisplayState;
}({});
